import { TableTemplate } from 'types/tableTemplate';

export const productTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'manufacturer',
    description: 'Fabricante',
    originalId: 'manufacturer',
    width: 200,
  },
  {
    id: 'unit',
    description: 'Unidade',
    originalId: 'unit',
    width: 100,
  },
];
